import type { Disposable } from '@patsnap/tahiti-core';

/** 报告辅助操作说明气泡的展示参数。 */
export interface ReportActionGuideBubbleShowOptions {
    /** 气泡需要跟随的报告操作按钮。 */
    target: Element;
    /** 当前语言下的操作说明。 */
    description: string;
}

/** 在 Driver 主气泡之外展示辅助报告操作说明。 */
export interface ReportActionGuideBubblePresenter {
    /** 挂载说明气泡，并返回幂等清理句柄。 */
    show(options: ReportActionGuideBubbleShowOptions): Disposable;
}

/** 报告辅助操作说明气泡 Presenter 的容器标识。 */
export const ReportActionGuideBubblePresenter = Symbol('ReportActionGuideBubblePresenter');
